@let teamMembersOverview =
  pulseFeature.selectors.teamMembersOverview.asSignal();

<atn-summit-pulse-section name="Team Member Overview">
  <div class="atn-summit-pulse-team-member-overview">
    @for (teamMember of teamMembersOverview; track $index) {
      <div class="atn-summit-pulse-team-member-overview__card">
        <div class="atn-summit-pulse-team-member-overview__card-header">
          <h4 class="atn-summit-pulse-team-member-overview__card-title">
            {{ teamMember.name }}
          </h4>
          <!-- <div class="atn-summit-pulse-team-member-overview__card-role">
            {{ teamMember.role }}
          </div> -->
        </div>
        <div class="atn-summit-pulse-team-member-overview__card-body">
          <div class="atn-summit-pulse-team-member-overview__card-section">
            <div>
              <span
                class="atn-summit-pulse-team-member-overview__card-section-title atn-summit-pulse-team-member-overview__card-section-title--highlight"
                >Highlight</span
              >
            </div>
            <div>{{ teamMember.highlight }}</div>
          </div>
          <div class="atn-summit-pulse-team-member-overview__card-section">
            <div>
              <span
                class="atn-summit-pulse-team-member-overview__card-section-title atn-summit-pulse-team-member-overview__card-section-title--concern"
                >Concern</span
              >
            </div>
            <div>{{ teamMember.concern }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</atn-summit-pulse-section>
